/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface DamageWaiverRef
 */
export interface DamageWaiverRefOptional {
  /**
   *
   * @type {number}
   * @memberof DamageWaiverRef
   */
  waiverId?: number;
}

export interface DamageWaiverRef extends DamageWaiverRefOptional {
  /**
   *
   * @type {number}
   * @memberof DamageWaiverRef
   */
  waiverId: number;
}

export interface DamageWaiverRefTrackedI {
  /**
   *
   * @type {number}
   * @memberof DamageWaiverRef
   */
  waiverId?: number;
  waiverIdIsSet: boolean;
}

transformDatesMap.set("DamageWaiverRef", function (model: DamageWaiverRef) {});

export type DamageWaiverRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  waiverId: PropertyMeta<MetaTypeBase<number>>;
}>;

export var DamageWaiverRefMeta: DamageWaiverRefMetaI =
  {} as DamageWaiverRefMetaI;
DamageWaiverRefMeta = typeMeta("DamageWaiverRef", {
  waiverId: propertyMeta("waiverId", false, true, true, MetaTypesBase.number),
});

const metaI = DamageWaiverRefMeta;

registerMeta(() => {});

export class DamageWaiverRefTracked implements DamageWaiverRefTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  waiverId__I?: number = undefined;

  get waiverIdIsSet() {
    return this.waiverId !== undefined;
  }
  set waiverIdIsSet(v: boolean) {}
  set waiverId(v: undefined | number) {
    if (v !== undefined) {
      this.waiverId__I = v;
      this.waiverIdIsSet = true;
    } else {
      this.waiverId__I = v || undefined;
      this.waiverIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get waiverId() {
    return this.waiverId__I;
  }
  constructor(config?: DamageWaiverRefOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.waiverIdIsSet == true && other?.waiverIdIsSet == true)
      return this.waiverId == other.waiverId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.waiverId) {
      this.waiverIdIsSet = true;
    }
  }
  assignFrom(
    config: DamageWaiverRefOptional,
    options?: AssignOptions,
  ): DamageWaiverRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.waiverId && this.waiverIdApplyFilter(optionsRequired.filter)) {
      this.waiverId = config.waiverId;
      if (optionsRequired.unassign) this.waiverIdIsSet = false;
      else this.waiverIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): DamageWaiverRefTrackedI {
    const cloned = {} as DamageWaiverRefTrackedI;
    if (
      this.waiverIdIsSetDeep() &&
      this.waiverIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.waiverIdIsSet = true;
      cloned.waiverId = this.waiverId;
    } else {
      //cloned.waiverIdIsSet = false
    }
    if (!isDeleted(this) && !this.waiverIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): DamageWaiverRefTrackedI {
    if (!this.waiverIdApplyFilter(filter)) this.waiverIdIsSet = false;

    return this;
  }
  waiverIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DamageWaiverRefMeta.waiverId,
      DamageWaiverRefMeta,
      this.waiverId,
      this,
    );
  }
  waiverIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.waiverIdIsSet && this.waiverIdApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.waiverIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
